module.exports = __webpack_public_path__ + "static/media/tea_set.0dc9473b.jpg";